/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SelectDropdownComponent} from './select-dropdown.component';
import {NgbDropdownModule} from '@ng-bootstrap/ng-bootstrap';
import {TooltipModule} from '../../../../tooltip/tooltip.module';

@NgModule({
    declarations: [SelectDropdownComponent],
    exports: [SelectDropdownComponent],
    imports: [
        CommonModule,
        NgbDropdownModule,
        TooltipModule
    ]
})
export class SelectDropdownModule {
}
